import z from 'zod';

import { client } from '~shared/api';

import { PositionDtoScheme, StaffingDto, StaffingDtoScheme } from '../dto';

export async function getStaffingsBySection(
	sectionId: number,
	departmentId: string,
	organizationId: string,
): Promise<StaffingDto[]> {
	const params = new URLSearchParams();

	params.set('section_id', String(sectionId));
	params.set('department_id', String(departmentId));
	params.set('organization_id', String(organizationId));

	const data = await client.get(`/staffing?${params.toString()}`);
	return z.array(StaffingDtoScheme).parse(data);
}

export async function getPositions(sectionId?: number | null) {
	const data = await client.get(`/position/section/${sectionId ?? ''}`);
	return z.array(PositionDtoScheme).parse(data);
}
